import { Trans } from '@lingui/react/macro'

import SelectBanners, { Props } from './SelectBanners'
import { EditBanners } from './EditBanners'

export function BannersField(props: Props) {
  const { readOnly } = props

  return (
    <>
      <div className="flex flex-row items-center justify-between gap-2">
        <label className="text-heading3 text-text">
          <Trans>Banners</Trans>
        </label>
        {!readOnly && <EditBanners />}
      </div>
      <SelectBanners {...props} />
    </>
  )
}
